import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../img/logo.png';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { Helmet } from 'react-helmet';
import Themes from '../components/Themes';
import PdfContent from '../components/pdf/PdfContent';
import LoadingScreen from '../components/LoadingScreen';
import NavBar from '../components/NavBar';

function Pdf() {
  const contentRef = useRef();
  const { id } = useParams();
  const { demoTheme } = useParams();
  const navigate = useNavigate();

  const [theme, setTheme] = useState('');
  const [walimatulurus, setWalimatulurus] = useState('');
  const [walimatulurus2, setWalimatulurus2] = useState('');
  const [doa, setDoa] = useState('');
  const [groomName, setGroomName] = useState('');
  const [brideName, setBrideName] = useState('');
  const [weddingDate, setWeddingDate] = useState('');
  const [parentName, setParentName] = useState('');
  const [message, setMessage] = useState('');
  const [groomFullname, setGroomFullname] = useState('');
  const [brideFullname, setBrideFullname] = useState('');
  const [location, setLocation] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [tentative, setTentative] = useState('');
  const [contacts, setContacts] = useState('');
  const [directions, setDirections] = useState('');
  const [H2, setH2] = useState('');
  const [fontP, setFontP] = useState('');
  const [H2size, setH2size] = useState('');
  const [showNotification, setShowNotification] = useState(false);
  const url = `${process.env.REACT_APP_BASE_URL}/kad/${id}`;

  const [loading, setLoading] = useState(true);

  const features = async (pakej) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/features/${pakej}`);
      const data = response.data;

      if (!data.pdf) {
        setShowNotification(true);
        setTimeout(() => {
          navigate(`/dashboard/${id}`);
        }, 3000);
        return;
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/kad/${id}`);
        const data = response.data;
  
        setTheme(demoTheme || data.theme);
        setWalimatulurus(data.walimatulurus);
        setWalimatulurus2(data.walimatulurus2);
        setDoa(data.doa);
        setGroomName(data.groom_name);
        setBrideName(data.bride_name);
        setWeddingDate(data.wedding_date);
        setParentName(data.parent_name);
        setMessage(data.message);
        setGroomFullname(data.groom_fullname);
        setBrideFullname(data.bride_fullname);
        setLocation(data.location);
        setStartTime(data.start_time);
        setEndTime(data.end_time);
        setTentative(data.tentative);
        setContacts(data.contacts);
        setDirections(data.directions);
        setH2(data.H2);
        setFontP(data.fontP);
        // setH2size(data.H2size);
        features(data.pakej);
        // setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
      }
    };
  
    fetchData();
  }, [id]);
  
  const description = `${walimatulurus} | ${groomName} x ${brideName}`;

  const [heroStyle, setHeroStyle] = useState();
  const [textColor, setTextColor] = useState('text-black');

  useEffect(() => {
    if (theme) {
      const Components = Themes[theme];
      setHeroStyle(Components.themeColor);
      setTextColor(Components.textColor);
      if(demoTheme) {
        setH2(Components.H2);
        setH2size(Components.H2Pdf);
        setFontP(Components.fontP);
      }
    }
  }, [theme]);

  const handleDownloadPDF = async () => {
    const content = contentRef.current;
  
    if (!content) {
      console.error("No content found for PDF generation.");
      return;
    }
  
    const sections = content.querySelectorAll(".a6-section");
  
    // Create PDF with A6 dimensions (105mm x 148mm)
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a6"
    });
  
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
  
      // Convert each section to canvas with higher quality
      const canvas = await html2canvas(section, {
        scale: 3, // Increased scale for better quality
        useCORS: true,
        logging: false,
        imageTimeout: 0
      });
      const imgData = canvas.toDataURL("image/png", 1.0);
  
      // Add to PDF - using A6 dimensions (105mm x 148mm)
      if (i > 0) pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, 0, 105, 148); // Full A6 page size
    }
  
    // Create filename using groomName and brideName
    const filename = `kad_kahwin_${groomName.toLowerCase().replace(/\s+/g, '_')}_${brideName.toLowerCase().replace(/\s+/g, '_')}.pdf`;
    pdf.save(filename);
  };  

  return (
    <div>
      <Helmet>
        <title>{description}</title>
        <meta name="description" content={description} />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {showNotification && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 bg-red-100 border border-red-400 text-red-700 px-6 py-3 rounded-lg shadow-lg z-50 animate-fade-in">
          <p className="text-center">Anda tiada akses untuk halaman PDF.</p>
        </div>
      )}
      {loading ? (
        <LoadingScreen logo={logo} /> 
      ) : (
        <div>
          <NavBar />
          <PdfContent {...{
            textColor, heroStyle, theme, walimatulurus, H2, fontP, H2size, groomName,
            brideName, weddingDate, walimatulurus2, parentName, message, groomFullname, brideFullname, 
            location, startTime, endTime, contacts, url, contentRef, handleDownloadPDF
          }} />
        </div>
      )}
    </div>
  );
}

export default Pdf;
